import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";

export class A3RunCommand {
    constructor(
        private readonly dispatcher: CommandDispatcher,
    ) { }

async run(companydb_id): Promise<any> {
        let args = {
            companydb_id: companydb_id
        }
        try {
            await this.dispatcher.dispatch('check.a3.path.command', args)
        } catch (error){
            console.log('Error while create run command', error)
        }
    }
}